import createLoginGatekeeper, { TokenCache } from './hooks/createLoginGatekeeper';
import { LOCAL_STORAGE_AUTH_ITEM } from './constants';

export const getAuthFromLocalStorage: () => TokenCache = () => localStorage.getItem(LOCAL_STORAGE_AUTH_ITEM)
  && JSON.parse(localStorage.getItem(LOCAL_STORAGE_AUTH_ITEM));

export { default as TokenRefresh } from './TokenRefresh/TokenRefresh';

export * from './constants';

export default createLoginGatekeeper;
